module.exports = __webpack_public_path__ + "img/BRCA2_Treg.70565a43.png";